import axios from 'axios'

/**
 * 用户登录
 * @param {string} phone - 手机号
 * @param {string} password - 密码
 * @param {string} loginLocation - 登录地点
 * @returns {Promise} 登录结果，包含token
 */
export function login(phone, password, loginLocation) {
    return axios({
        url: '/auth/login',
        method: 'post',
        data: {
            phone,
            password,
            loginLocation
        }
    })
}

/**
 * 用户登出
 * @returns {Promise} 登出结果
 */
export function logout() {
    return axios({
        url: '/auth/logout',
        method: 'post'
    })
}

/**
 * 用户注册
 * @param {Object} userData - 注册信息
 * @returns {Promise} 注册结果
 */
export function register(userData) {
    return axios({
        url: '/auth/register',
        method: 'post',
        data: userData
    })
}

/**
 * 修改密码
 * @param {Object} passwordData - 包含旧密码和新密码
 * @returns {Promise} 修改结果
 */
export function changePassword(passwordData) {
    return axios({
        url: `/auth/changePassword`,
        method: 'post',
        data: passwordData
    })
}

/**
 * 通过姓名和身份证号查找用户ID
 * @param {string} name - 姓名
 * @param {string} idCardNumber - 身份证号
 * @returns {Promise} 用户ID
 */
export function findUserIdByNameAndIdCard(name, idCardNumber) {
    return axios({
        url: `/auth/findUserId`,
        method: 'get',
        params: {
            name,
            idCardNumber
        }
    })
}

/**
 * 验证Token有效性
 * @returns {Promise} 验证结果
 */
export function verifyToken() {
    return axios({
        url: '/auth/verifyToken',
        method: 'post'
    })
}

/**
 * 刷新Token
 * @returns {Promise} 新的token
 */
export function refreshToken() {
    return axios({
        url: '/auth/refreshToken',
        method: 'post'
    })
}

/**
 * 验证手机号是否已注册
 * @param {string} phoneNumber - 手机号
 * @returns {Promise} 验证结果
 */
export function validatePhone(phoneNumber) {
    return axios({
        url: '/auth/validate/phone',
        method: 'post',
        data: phoneNumber
    })
}

/**
 * 验证身份证号是否已注册
 * @param {string} idCardNumber - 身份证号
 * @returns {Promise} 验证结果
 */
export function validateIdCard(idCardNumber) {
    return axios({
        url: '/auth/validate/idcard',
        method: 'post',
        data: idCardNumber
    })
}

/**
 * 获取Coze Token（用于智能客服）
 * @param {string} userId - 用户ID
 * @returns {Promise} 包含accessToken和botId的结果
 */
export function fetchCozeToken() {
    return axios({
        url: '/auth/coze/token',
        method: 'post'
    })
}
